import { TOOLTIP_POSITION_DEFAULT_RETURN } from '../constants.js';
import { eventPointNative, getXYFromEventType } from './eventPoint.js';

function getDonutChartTooltipPosition({
  containerBounds,
  event,
  eventType,
  index,
  parentElement
}) {
  if (index == null) {
    return TOOLTIP_POSITION_DEFAULT_RETURN;
  }
  if (eventType === 'mouse' && (event instanceof MouseEvent || event instanceof TouchEvent)) {
    if (index == null || event == null) {
      return TOOLTIP_POSITION_DEFAULT_RETURN;
    }
    const point = eventPointNative(event);
    if (point == null) {
      return TOOLTIP_POSITION_DEFAULT_RETURN;
    }
    const {
      x,
      y
    } = getXYFromEventType(event);
    return {
      x,
      y,
      activeIndex: index
    };
  } else {
    if ((event === null || event === void 0 ? void 0 : event.target) == null || parentElement == null) {
      return TOOLTIP_POSITION_DEFAULT_RETURN;
    }
    const parentWidth = parentElement.clientWidth;
    const startAngle = event.target.getAttribute('data-start-angle');
    const endAngle = event.target.getAttribute('data-end-angle');
    const leftOffset = containerBounds.width - parentWidth;
    const radius = Math.min(containerBounds.width - leftOffset, containerBounds.height) / 2;
    const centerX = containerBounds.x + leftOffset + radius;
    const centerY = containerBounds.y + containerBounds.height / 2;
    const midAngle = (Number(startAngle) + Number(endAngle)) / 2;
    const x = centerX + radius * Math.cos(midAngle - Math.PI / 2);
    const y = centerY + radius * Math.sin(midAngle - Math.PI / 2);
    return {
      x,
      y,
      activeIndex: index
    };
  }
}

export { getDonutChartTooltipPosition };
